module.exports = __webpack_public_path__ + "static/hero-ad4e8a36cf4a7dd44e88434bf9441334.jpg";